var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDatepicker({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.00065V12.334C0 12.6876 0.140476 13.0267 0.390524 13.2768C0.640573 13.5268 0.979711 13.6673 1.33333 13.6673H10.6667C11.0203 13.6673 11.3594 13.5268 11.6095 13.2768C11.8595 13.0267 12 12.6876 12 12.334V3.00065C12 2.64703 11.8595 2.30789 11.6095 2.05784C11.3594 1.80779 11.0203 1.66732 10.6667 1.66732H9.33333V0.333984H8V1.66732H4V0.333984H2.66667V1.66732H1.33333C0.979711 1.66732 0.640573 1.80779 0.390524 2.05784C0.140476 2.30789 0 2.64703 0 3.00065ZM10.6667 12.334H1.33333V4.33398H10.6667V12.334Z",
    fill: "#74788D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatepicker);
export default __webpack_public_path__ + "static/media/datepicker.837812ea56547bb8cf34c93435e56473.svg";
export { ForwardRef as ReactComponent };